import { Outlet } from 'react-router';
import React, { useEffect, useMemo } from 'react';
import { useAppDispatch } from 'store/store';
import { setClientCobrand } from 'features/cobrand/cobrandSlice';
import { getCobrandFromHostName } from 'features/cobrand/utils/cobrandUtils';
import { CobrandIdentifier } from 'features/cobrand/types';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';

/**
 * Route guard for hostname-based cobrand detection.
 * Detects cobrand from hostname and dispatches to Redux store.
 * Used for routes without cobrand in path (e.g., caremanagement.carefirst.com/home).
 */
export const HostCobrandGuard: React.FC = () => {
  const dispatch = useAppDispatch();
  const { setCobrandTheme } = useThemeUtils();

  // Memoize cobrand detection to prevent recalculation on every render
  const cobrandId = useMemo(() => {
    const cobrandFromHost = getCobrandFromHostName();
    return cobrandFromHost ?? CobrandIdentifier.WELLFRAME;
  }, []);

  useEffect(() => {
    // Set client cobrand in Redux store and update theme
    setCobrandTheme(cobrandId);
    dispatch(setClientCobrand(cobrandId));
  }, [cobrandId, dispatch, setCobrandTheme]);

  return <Outlet />;
};
